
define(
  'MyAccount.EntryPoint',
  [

  ],
  function (

  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {

      }
    };
  }
);
